// extracted by mini-css-extract-plugin
module.exports = {"container":"StandaloneImageBlock_container__J_ysQ","image":"StandaloneImageBlock_image__1auzS"};